import { type EntitlementAccessConfig } from '@webapp/core/services/Entitlement/types'
import {
  type FeatureFlagKey,
  type FeatureFlags,
} from '@webapp/core/services/FeatureFlag'
import {
  UPDATE_FEATURE_FLAG,
  UPDATE_FEATURE_FLAGS,
  UPDATE_FEATURE_SWITCH,
  UPDATE_GLOBAL_CONTEXT,
  UPDATE_IS_PAY_SETUP,
  UPDATE_ORDER_CUSTOMFIELD,
  UPDATE_ORDER_ITEM_CUSTOMFIELD,
  UPDATE_USER,
  UPDATE_ENTITLEMENT_ACCESS_CONFIG,
} from './constants'
import {
  type UpdateOrderItemCustomFieldAction,
  type IGlobalState,
  type UpdateFeatureFlagAction,
  type UpdateFeatureFlagsAction,
  type UpdateFeatureSwitchAction,
  type UpdateGlobalAction,
  type UpdateIsPaySetupAction,
  type UpdateOrderCustomFieldAction,
  type UpdateUserAction,
  type UpdateEntitlementAccessConfig,
} from './types'
import { type Currency, type CustomField, type User } from '../../../models'

export const SET_BASE_CURRENCY =
  'app/hoc/ApplicationContextProvider/SET_BASE_CURRENCY'

export interface SetBaseCurrencyAction {
  type: typeof SET_BASE_CURRENCY
  baseCurrency: Currency
}

export const updateGlobal = (
  global: Partial<IGlobalState>
): UpdateGlobalAction => ({ type: UPDATE_GLOBAL_CONTEXT, global })

export const updateOrderCustomfield = (
  customfields: CustomField[]
): UpdateOrderCustomFieldAction => ({
  type: UPDATE_ORDER_CUSTOMFIELD,
  customfields,
})

export const updateOrderItemCustomfield = (
  customfields: CustomField[]
): UpdateOrderItemCustomFieldAction => ({
  type: UPDATE_ORDER_ITEM_CUSTOMFIELD,
  customfields,
})

export const updateUser = (user: Partial<User>): UpdateUserAction => {
  return {
    type: UPDATE_USER,
    user,
  }
}

export const updateFlag = (
  flag: FeatureFlagKey,
  value
): UpdateFeatureFlagAction => {
  return { type: UPDATE_FEATURE_FLAG, flag, value }
}

export const updateFlags = (
  flags: Partial<FeatureFlags>
): UpdateFeatureFlagsAction => {
  return { type: UPDATE_FEATURE_FLAGS, flags }
}

export const updateFeatureSwitch = (flag, value): UpdateFeatureSwitchAction => {
  return { type: UPDATE_FEATURE_SWITCH, flag, value }
}

export const updateIsPaySetUp = (value: boolean): UpdateIsPaySetupAction => {
  return { type: UPDATE_IS_PAY_SETUP, value }
}

export const updateEntitlementAccessConfig = (
  value: EntitlementAccessConfig
): UpdateEntitlementAccessConfig => {
  return { type: UPDATE_ENTITLEMENT_ACCESS_CONFIG, value }
}

export const setBaseCurrency = (
  baseCurrency: Currency
): SetBaseCurrencyAction => {
  return { type: SET_BASE_CURRENCY, baseCurrency }
}
